export enum FulfillmentStepActionType {
  AssignAgent = "AssignAgent",
  AutoAssignAgent = "AutoAssignAgent",
  AssignToRoute = "AssignToRoute",
  CancelService = "CancelService",
  CompleteManually = "CompleteManually",
  AddNote = "AddNote",
  CreateRoute = "CreateRoute",
  SendToDispatch = "SendToDispatch",
  SplitStep = "SplitStep",
  AssignResourceAllocation = "AssignResourceAllocation",
  Reset = "Reset",
  CreateVoucher = "CreateVoucher",
  SendToPlanning = "SendToPlanning",
  ManualHandle = "ManualHandle",
  CancelLeg = "CancelLeg",
  MultiAssign = "MultiAssign"
}
